import Clickoutslide from "./clickoutslide";

function install(Vue) {
  Vue.directive("Clickoutside", Clickoutslide);
}
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
Clickoutslide.install = install;
export default Clickoutslide;
